/**
 * mos-sticky-sync.js
 * Keeps the sticky add-to-cart bar in sync with the Appstle
 * subscription/one-time selection.
 *
 * Subscription selected → shows ~~original~~ discounted price + "Subscribe & Save"
 * One-time selected     → shows regular price only + "Add to cart"
 */

(function () {
  'use strict';

  function syncStickyCart() {
    // --- Read current Appstle state ---
    const discountedPriceEl = document.querySelector('.appstle_subscription_final_price');
    const checkedPlan = document.querySelector('[id*="appstle_selling_plan"]:checked');
    const isSubscription = checkedPlan && checkedPlan.value !== '';

    // Read discounted price (Appstle has already updated this by the time the event fires)
    const discountedPrice = discountedPriceEl ? discountedPriceEl.textContent.trim() : null;

    // Read original (full) price from Appstle's own compare-at element —
    // this is the most reliable source: correct price, no label text
    const compareAtEl = document.querySelector(
      '.appstle_subscription_compare_amount'
    );
    const originalPrice = compareAtEl
      ? compareAtEl.textContent.trim()
      : null;

    // --- Update sticky price container ---
    const stickyPriceContainer = document.querySelector('[data-js-atc-price]');
    if (stickyPriceContainer) {
      if (isSubscription && discountedPrice && originalPrice) {
        // Show crossed-out original + discounted price side by side
        stickyPriceContainer.innerHTML =
          '<span class="sticky-add-to-cart__price-compare" ' +
          'style="text-decoration:line-through;opacity:0.5;margin-right:6px;font-weight:400;">' +
          originalPrice +
          '</span>' +
          '<span class="sticky-add-to-cart__price-original text-weight--bold">' +
          discountedPrice +
          '</span>';
      } else if (isSubscription && discountedPrice) {
        // Subscription but no compare-at found — show discounted price only
        stickyPriceContainer.innerHTML =
          '<span class="sticky-add-to-cart__price-original text-weight--bold">' +
          discountedPrice +
          '</span>';
      } else {
        // One-time purchase — restore single regular price
        const regularPrice = originalPrice || discountedPrice;
        stickyPriceContainer.innerHTML =
          '<span class="sticky-add-to-cart__price-original text-weight--bold">' +
          (regularPrice || '') +
          '</span>';
      }
    }

    // --- Update sticky button text ---
    const stickyBtnText = document.querySelector('[data-js-atc] .button__text');
    if (stickyBtnText) {
      stickyBtnText.textContent = isSubscription ? 'Subscribe & Save' : 'Add to cart';
    }
  }

  // AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated fires last —
  // safe to read updated price from DOM at this point
  document.addEventListener(
    'AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated',
    syncStickyCart
  );

  // Run on page load after Appstle has had time to initialise
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(syncStickyCart, 800);
  });

})();
